var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:[_vm.buttonStyleClass, _vm.buttonSizeClass],attrs:{"type":"button"},on:{"click":_vm.navigateBack}},[_c('i',{staticClass:"fas fa-angle-left fa-lg"}),_vm._v("  "),_vm._t("default",function(){return [_vm._v("Back")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }